import { Injectable } from '@angular/core';
import { ApiService } from '@uranda/commons';
import { Country } from '../../../../../model/country.model';
import { Region } from '../../../../../model/region.model';
import { HttpParams } from '@angular/common/http';
import { City } from '../../../../../model/city.model';
import { District } from '../../../../../model/district.model';

@Injectable({
    providedIn: 'root'
})
export class LocationService extends ApiService {


    async getCountries(): Promise<Country[]> {
        return (await (this.get('/v1/geo/countries'))).data
    }

    async getRegions(countryId?: string): Promise<Region[]> {
        const params = new HttpParams().set('countryId', countryId?.toString() ?? '');
        return (await this.get('/v1/geo/regions', params)).data;
    }

    async getDistricts(regionId?: number): Promise<District[]> {
        const params = new HttpParams().set('regionId', regionId?.toString() ?? '');
        return (await this.get('/v1/geo/districts', params)).data;
    }

}